<div class="container py-4">
  <div class="row justify-content-center">
    <div class="col-md-7">
      <div class="card shadow-sm border-0">
        <div class="card-body">

          <h3 class="fw-bold text-center mb-4">Create PayPal Plan</h3>

          @if (loading) {
            <div class="alert alert-info text-center">{{ statusMessage }}</div>
          }

          @if (!planCreated) {
            <form (ngSubmit)="createSubscriptionFlow()">
              <label class="fw-semibold">Product Name</label>
              <input class="form-control" [(ngModel)]="product.name" name="name" required />
              <div class="row">
                <!-- Price -->
                <div class="col-md-4">
                  <label class="fw-semibold mt-3">Price</label>
                  <input class="form-control no-arrows" type="number" [(ngModel)]="plan.price" name="price" required />
                </div>
                <!-- Currency -->
                <div class="col-md-4">
                  <label class="fw-semibold mt-3">Currency</label>
                  <select class="form-select" [(ngModel)]="plan.currency" name="currency" required>
                    <option value="USD" selected>USD ($)</option>
                    <option value="EUR">EUR (€)</option>
                  </select>
                </div>
                <!-- Billing -->
                <div class="col-md-4">
                  <label class="fw-semibold mt-3">Billing</label>
                  <select class="form-select" [(ngModel)]="plan.billing" name="billing" required>
                    <option value="WEEK">Weekly</option>
                    <option value="MONTH">Monthly</option>
                    <option value="YEAR">Yearly</option>
                  </select>
                </div>
              </div>
              <label class="fw-semibold mt-3">Remark</label>
              <textarea class="form-control" [(ngModel)]="product.description" name="description" required></textarea>
              <button class="btn btn-dark w-100 mt-4">
                {{ loading ? "Processing..." : "Create a Plan" }}
              </button>
            </form>
          }

          @if (planCreated) {
            <hr class="my-4" />
          }

          @if (planCreated) {
            <div class="alert alert-success">
              <h4 class="fw-semibold text-center text-primary mb-4 title-style">
                Plan Created Successfully 🎉
              </h4>
              <p><strong>Product ID:</strong> {{ createdProductId }}</p>
              <p><strong>Product:</strong> {{ product.name }}</p>
              <p><strong>Plan ID:</strong> {{ createdPlanId }}</p>
              <p><strong>Currency:</strong> {{ plan.currency }}</p>
              <p><strong>Billing Cycle:</strong> {{ plan.billing }}</p>
              <p><strong>Price: </strong> {{ currencySymbols[plan.currency] }} {{ plan.price }}</p>
              <button class="btn btn-success w-100" (click)="startSubscription()">Activate Plan</button>
            </div>
          }

        </div>
      </div>
    </div>
  </div>
</div>